import { render, staticRenderFns } from "./propertyOwnerManageList.vue?vue&type=template&id=0930ef25&scoped=true"
import script from "./propertyOwnerManageList.vue?vue&type=script&lang=js"
export * from "./propertyOwnerManageList.vue?vue&type=script&lang=js"
import style0 from "./propertyOwnerManageList.vue?vue&type=style&index=0&id=0930ef25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930ef25",
  null
  
)

export default component.exports